import * as api from "../apis/audiencesApi";
import {
  useQuery,
  useQueryClient,
  queryOptions,
  useSuspenseQuery,
} from "@tanstack/react-query";


// Query options

export const getAudiencesQueryOptions = () =>
  queryOptions({
    queryKey: ["audiences"],
    queryFn: api.getAudiences,
    refetchOnWindowFocus: "always",
    
  });

export const getAudiencesByAdAccountQueryOptions = (
  adAccountId,
  queryClient
) =>
  queryOptions({
    queryKey: ["adAccount.audiences", adAccountId],
    queryFn: () => api.getAudiencesByAdAccount(adAccountId),
    refetchOnWindowFocus: "always",
    
    initialData: () =>
      queryClient
        .getQueryData(["audiences"])
        ?.filter((audience) => audience.adAccount.id === adAccountId),
    initialDataUpdatedAt: () =>
      queryClient.getQueryState(["audiences"])?.dataUpdatedAt,
  });

export const getAudienceQueryOptions = (id, queryClient) => {
  let queryKey;

  return queryOptions({
    queryKey: ["audience", id],
    queryFn: () => api.getAudience(id),
    refetchOnWindowFocus: "always",
    
    initialData: () => {
      // if "audiences" query exist, we use it to init data
      if (queryClient.getQueryState(["audiences"])) {
        queryKey = ["audiences"];
        return queryClient
          .getQueryData(["audiences"])
          ?.find((audience) => audience.id === id);
      }

      // otherwise, we try to find the audience in one of the "account.audiences" queries
      let found;

      queryClient
        .getQueriesData({ queryKey: ["account.audiences"] })
        .forEach((query) => {
          const data = query[1];
          data.forEach((audience) => {
            if (audience.id === id) {
              found = audience;
              queryKey = query[0];
            }
          });
        });

      // otherwise, we try to find the audience in one of the "adAccount.audiences" queries
      if (!found) {
        queryClient
          .getQueriesData({ queryKey: ["adAccount.audiences"] })
          .forEach((query) => {
            const data = query[1];
            data.forEach((audience) => {
              if (audience.id === id) {
                found = audience;
                queryKey = query[0];
              }
            });
          });
      }

      return found;
    },
    initialDataUpdatedAt: () =>
      queryClient.getQueryState(queryKey)?.dataUpdatedAt,
  });
};

// useQuery

export const useGetAudiences = () => useQuery(getAudiencesQueryOptions());

export const useGetAudiencesByAdAccount = (adAccountId) => {
  const queryClient = useQueryClient();
  return useQuery(
    getAudiencesByAdAccountQueryOptions(adAccountId, queryClient)
  );
};

export const useGetAudience = (id) => {
  const queryClient = useQueryClient();
  return useQuery(getAudienceQueryOptions(id, queryClient));
};

// useSuspenseQuery

export const useSuspenseGetAudiences = () =>
  useSuspenseQuery(getAudiencesQueryOptions());

export const useSuspenseGetAudiencesByAdAccount = (adAccountId) => {
  const queryClient = useQueryClient();
  return useSuspenseQuery(
    getAudiencesByAdAccountQueryOptions(adAccountId, queryClient)
  );
};

export const useSuspenseGetAudience = (id) => {
  const queryClient = useQueryClient();
  return useSuspenseQuery(getAudienceQueryOptions(id, queryClient));
};
